<style lang="less" scoped>

</style>

<template lang="pug">
</template>

<script>
export default {
  data() {
    return {
      message: '게임 시작을 위해 코드를 입력해주세요.',
    };
  },
  methods: {
    getCode() {
      const code = 'memorysports2018!@';
      return window.prompt(this.message) === code;
    },
    success() {
      this.$store.commit('setAuth', true);
      this.$router.replace('/');
      return true;
    },
    failed() {
      alert('정확한 코드를 입력해주세요!');
    },
    cycle() {
      if (this.getCode()) {
        this.success();
      } else {
        this.failed();
        this.cycle();
      }
    },
  },
  mounted() {
    this.cycle();
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/auth.vue